// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// // import {
// //   useGetApplicationsByBorrowerQuery,
// //   useSendMessageMutation
// // } from './loanApplicationApiSlice';

// import { useGetApplicationsByBorrowerQuery,useSendMessageMutation } from '../../services/loanApplicationApiSlice';

// const LoanApplications = () => {
//   const navigate = useNavigate();
//   // Get user from localStorage
//   const user = JSON.parse(localStorage.getItem('user'));
//   const userId = user?.userId || '';
  
//   // Fetch loan applications for the current borrower
//   const {
//     data: applications = [],
//     isLoading,
//     isError,
//     error,
//     refetch
//   } = useGetApplicationsByBorrowerQuery(userId);
  
//   const [sendMessage, { isLoading: isSending }] = useSendMessageMutation();
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });

//   // Refetch data on component mount
//   useEffect(() => {
//     refetch();
//   }, [refetch]);

//   // Handle sorting
//   const handleSort = (key) => {
//     let direction = 'ascending';
//     if (sortConfig.key === key && sortConfig.direction === 'ascending') {
//       direction = 'descending';
//     }
//     setSortConfig({ key, direction });
//   };

//   // Sort applications
//   const sortedApplications = [...applications].sort((a, b) => {
//     if (!sortConfig.key) return 0;
    
//     if (a[sortConfig.key] < b[sortConfig.key]) {
//       return sortConfig.direction === 'ascending' ? -1 : 1;
//     }
//     if (a[sortConfig.key] > b[sortConfig.key]) {
//       return sortConfig.direction === 'ascending' ? 1 : -1;
//     }
//     return 0;
//   });

//   // Format currency
//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat('LKR', {
//       style: 'currency',
//       currency: 'LKR',
//       minimumFractionDigits: 2
//     }).format(amount || 0);
//   };

//   // Format interest rate
//   const formatInterest = (rate) => {
//     return `${rate || 0}%`;
//   };

//   // Get status badge color
//   const getStatusColor = (status) => {
//     switch (status?.toLowerCase()) {
//       case 'approved':
//       case 'accepted':
//         return 'bg-emerald-50 text-emerald-700 border border-emerald-200';
//       case 'rejected':
//         return 'bg-rose-50 text-rose-700 border border-rose-200';
//       case 'pending':
//         return 'bg-amber-50 text-amber-700 border border-amber-200';
//       case 'under review':
//         return 'bg-sky-50 text-sky-700 border border-sky-200';
//       default:
//         return 'bg-slate-50 text-slate-700 border border-slate-200';
//     }
//   };

//   // Get status icon
//   const getStatusIcon = (status) => {
//     switch (status?.toLowerCase()) {
//       case 'approved':
//       case 'accepted':
//         return (
//           <svg className="w-3.5 h-3.5 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
//           </svg>
//         );
//       case 'rejected':
//         return (
//           <svg className="w-3.5 h-3.5 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
//           </svg>
//         );
//       case 'pending':
//         return (
//           <svg className="w-3.5 h-3.5 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
//           </svg>
//         );
//       case 'under review':
//         return (
//           <svg className="w-3.5 h-3.5 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//           </svg>
//         );
//       default:
//         return (
//           <svg className="w-3.5 h-3.5 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//           </svg>
//         );
//     }
//   };

//   // Get stat card icon and color
//   const getStatConfig = (type) => {
//     switch (type) {
//       case 'accepted':
//         return {
//           icon: (
//             <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
//             </svg>
//           ),
//           bgColor: 'bg-emerald-50',
//           iconColor: 'text-emerald-600'
//         };
//       case 'pending':
//         return {
//           icon: (
//             <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
//             </svg>
//           ),
//           bgColor: 'bg-amber-50',
//           iconColor: 'text-amber-600'
//         };
//       case 'rejected':
//         return {
//           icon: (
//             <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
//             </svg>
//           ),
//           bgColor: 'bg-rose-50',
//           iconColor: 'text-rose-600'
//         };
//       case 'total':
//       default:
//         return {
//           icon: (
//             <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
//             </svg>
//           ),
//           bgColor: 'bg-slate-50',
//           iconColor: 'text-slate-600'
//         };
//     }
//   };

//   // Handle sending message
//   // const handleSendMessage = async () => {
//   //   try {
//   //     const message = "Hello, this is a reminder about your loan application status.";
//   //     await sendMessage({ phone: user?.phone, message }).unwrap();
//   //     alert('Message sent successfully!');
//   //   } catch (err) {
//   //     console.error('Failed to send message:', err);
//   //     alert('Failed to send message');
//   //   }
//   // };

//   // Loading state
//   if (isLoading) {
//     return (
//       <div className="flex items-center justify-center min-h-[400px]">
//         <div className="text-center">
//           <div className="relative">
//             <div className="w-16 h-16 border-4 border-slate-200 rounded-full"></div>
//             <div className="absolute top-0 left-0 w-16 h-16 border-4 border-indigo-600 rounded-full border-t-transparent animate-spin"></div>
//           </div>
//           <p className="mt-4 text-sm font-medium text-slate-600">Loading your applications...</p>
//         </div>
//       </div>
//     );
//   }

//   // Error state
//   if (isError) {
//     return (
//       <div className="mx-auto max-w-xl mt-8">
//         <div className="bg-rose-50 border border-rose-200 rounded-xl p-6 shadow-sm">
//           <div className="flex items-start">
//             <div className="flex-shrink-0">
//               <svg className="w-5 h-5 text-rose-600 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M10 18a8 8 0 0-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
//               </svg>
//             </div>
//             <div className="ml-4">
//               <h3 className="text-sm font-semibold text-rose-800">Unable to load applications</h3>
//               <p className="mt-1.5 text-sm text-rose-600">{error?.data?.message || 'Something went wrong. Please try again later.'}</p>
//               <button 
//                 onClick={() => refetch()}
//                 className="mt-4 inline-flex items-center px-3.5 py-2 text-sm font-medium text-rose-700 bg-rose-100 rounded-lg hover:bg-rose-200 transition-colors"
//               >
//                 <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
//                 </svg>
//                 Try Again
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // Empty state
//   if (!applications || applications.length === 0) {
//     return (
//       <div className="max-w-md mx-auto mt-12">
//         <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 text-center">
//           <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-6">
//             <svg className="w-10 h-10 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
//             </svg>
//           </div>
//           <h3 className="text-xl font-semibold text-slate-900 mb-2">No Applications Yet</h3>
//           <p className="text-slate-500 mb-8">You haven't submitted any loan applications. Get started by applying for your first loan.</p>
//           <button 
//             onClick={() => navigate('/apply-loan')}
//             className="inline-flex items-center px-6 py-3 bg-indigo-600 text-white font-medium rounded-xl hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-all shadow-lg shadow-indigo-600/20"
//           >
//             <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
//             </svg>
//             Apply for a Loan
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="px-4 sm:px-6 lg:px-8 py-8 bg-slate-50 min-h-screen">
//       <div className="max-w-7xl mx-auto">
//         {/* Header */}
//         <div className="mb-8">
//           <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
//             <div>
//               <h1 className="text-2xl font-bold text-slate-900">Loan Applications</h1>
//               <p className="mt-1.5 text-sm text-slate-500">Track and manage your loan applications</p>
//             </div>
//             <button
//               onClick={() => navigate('/apply-loan')}
//               className="inline-flex items-center px-5 py-2.5 bg-indigo-600 text-white font-medium rounded-xl hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-all shadow-lg shadow-indigo-600/20"
//             >
//               <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
//               </svg>
//               New Application
//             </button>
//           </div>
//         </div>

//         {/* Stats Cards */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
//           {[
//             { type: 'accepted', label: 'Accepted', count: applications.filter(app => app.status?.toLowerCase() === 'accepted').length },
//             { type: 'pending', label: 'Pending', count: applications.filter(app => app.status?.toLowerCase() === 'pending').length },
//             { type: 'total', label: 'Total', count: applications.length },
//             { type: 'rejected', label: 'Rejected', count: applications.filter(app => app.status?.toLowerCase() === 'rejected').length }
//           ].map((stat, index) => {
//             const config = getStatConfig(stat.type);
//             return (
//               <div 
//                 key={stat.type}
//                 className="bg-white rounded-xl shadow-sm border border-slate-200 p-5 hover:shadow-md transition-shadow duration-200"
//               >
//                 <div className="flex items-center justify-between">
//                   <div className={`${config.bgColor} rounded-xl p-3`}>
//                     <div className={config.iconColor}>
//                       {config.icon}
//                     </div>
//                   </div>
//                   <div className="text-right">
//                     <p className="text-2xl font-bold text-slate-900">{stat.count}</p>
//                     <p className="text-sm text-slate-500">{stat.label}</p>
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//         </div>

//         {/* Table Card */}
//         <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
//           {/* Table Header */}
//           <div className="px-6 py-4 border-b border-slate-200 bg-slate-50/50">
//             <div className="flex items-center justify-between">
//               <h2 className="text-base font-semibold text-slate-900">Application Details</h2>
//               <span className="text-sm text-slate-500">{applications.length} applications</span>
//             </div>
//           </div>

//           <div className="overflow-x-auto">
//             <table className="w-full">
//               <thead className="bg-slate-50">
//                 <tr>
//                   {[
//                     { key: 'applicationId', label: 'ID' },
//                     { key: 'loanProductName', label: 'Loan Product' },
//                     { key: 'requestedAmount', label: 'Amount' },
//                     { key: 'requestedTermMonths', label: 'Term' },
//                     { key: 'interestRate', label: 'Interest Rate' },
//                     { key: 'status', label: 'Status' },
//                     { key: null, label: 'Actions' }
//                   ].map((column) => (
//                     <th
//                       key={column.key}
//                       onClick={() => column.key && handleSort(column.key)}
//                       className={`px-6 py-3.5 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider ${column.key ? 'cursor-pointer hover:bg-slate-100 transition-colors' : ''}`}
//                     >
//                       <div className="flex items-center gap-1.5">
//                         {column.label}
//                         {column.key && sortConfig.key === column.key && (
//                           <svg 
//                             className={`w-4 h-4 text-indigo-600 ${sortConfig.direction === 'descending' ? 'rotate-180' : ''}`} 
//                             fill="none" 
//                             stroke="currentColor" 
//                             viewBox="0 0 24 24"
//                           >
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7" />
//                           </svg>
//                         )}
//                       </div>
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-slate-100">
//                 {sortedApplications.map((application, index) => (
//                   <tr 
//                     key={application.applicationId}
//                     className={`hover:bg-slate-50/80 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-slate-50/30'}`}
//                   >
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <span className="text-sm font-semibold text-slate-900">#{application.applicationId}</span>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="flex items-center gap-3">
//                         <div className="w-10 h-10 bg-gradient-to-br from-indigo-50 to-purple-50 rounded-lg flex items-center justify-center flex-shrink-0">
//                           <svg className="w-5 h-5 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                           </svg>
//                         </div>
//                         <div>
//                           <p className="text-sm font-medium text-slate-900">{application.loanProductName || 'Personal Loan'}</p>
//                           <p className="text-xs text-slate-500">
//                             {new Date(application.requestedAt || Date.now()).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
//                           </p>
//                         </div>
//                       </div>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <span className="text-sm font-semibold text-slate-900">{formatCurrency(application.requestedAmount)}</span>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <span className="text-sm text-slate-700">{application.requestedTermMonths || 'N/A'} months</span>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <span className="text-sm font-semibold text-slate-700">{formatInterest(application.interestRate)}</span>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${getStatusColor(application.status)}`}>
//                         {getStatusIcon(application.status)}
//                         <span>{application.status || 'Pending'}</span>
//                       </span>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="flex items-center gap-2">
//                         <button 
//                           className="inline-flex items-center px-3 py-1.5 text-xs font-medium text-indigo-700 bg-indigo-50 rounded-lg hover:bg-indigo-100 transition-colors"
//                         >
//                           <svg className="w-3.5 h-3.5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
//                           </svg>
//                           View
//                         </button>
//                         <button 
//                           className="p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors"
//                           title="Get Updates"
//                         >
//                           <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
//                           </svg>
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* Table Footer */}
//           <div className="px-6 py-4 border-t border-slate-200 bg-slate-50/30">
//             <div className="flex items-center justify-between">
//               <p className="text-sm text-slate-500">
//                 Showing <span className="font-medium text-slate-700">{applications.length}</span> of <span className="font-medium text-slate-700">{applications.length}</span> applications
//               </p>
//               <div className="flex items-center gap-1">
//                 <button 
//                   disabled
//                   className="px-3 py-1.5 text-sm text-slate-400 bg-slate-100 rounded-lg cursor-not-allowed"
//                 >
//                   Previous
//                 </button>
//                 <button className="px-3 py-1.5 text-sm text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-colors">
//                   1
//                 </button>
//                 <button 
//                   disabled
//                   className="px-3 py-1.5 text-sm text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-lg transition-colors"
//                 >
//                   Next
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoanApplications;


import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetApplicationsByBorrowerQuery, useSendMessageMutation } from '../../services/loanApplicationApiSlice';

const LoanApplications = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));
  const userId = user?.userId || '';
  
  const {
    data: applications = [],
    isLoading,
    isError,
    error,
    refetch
  } = useGetApplicationsByBorrowerQuery(userId);
  
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });

  useEffect(() => {
    refetch();
  }, [refetch]);

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const sortedApplications = [...applications].sort((a, b) => {
    if (!sortConfig.key) return 0;
    
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === 'ascending' ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === 'ascending' ? 1 : -1;
    }
    return 0;
  });

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('LKR', {
      style: 'currency',
      currency: 'LKR',
      minimumFractionDigits: 2
    }).format(amount || 0);
  };

  const formatInterest = (rate) => {
    return `${rate || 0}%`;
  };

  const getStatusConfig = (status) => {
    const statusMap = {
      'approved': { 
        bg: 'bg-emerald-50', 
        text: 'text-emerald-700',
        border: 'border-emerald-100',
        icon: (
          <svg className="w-3.5 h-3.5 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
        )
      },
      'accepted': { 
        bg: 'bg-emerald-50', 
        text: 'text-emerald-700',
        border: 'border-emerald-100',
        icon: (
          <svg className="w-3.5 h-3.5 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
        )
      },
      'rejected': { 
        bg: 'bg-rose-50', 
        text: 'text-rose-700',
        border: 'border-rose-100',
        icon: (
          <svg className="w-3.5 h-3.5 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        )
      },
      'pending': { 
        bg: 'bg-amber-50', 
        text: 'text-amber-700',
        border: 'border-amber-100',
        icon: (
          <svg className="w-3.5 h-3.5 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        )
      },
      'under review': { 
        bg: 'bg-blue-50', 
        text: 'text-blue-700',
        border: 'border-blue-100',
        icon: (
          <svg className="w-3.5 h-3.5 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
        )
      },
      'default': { 
        bg: 'bg-slate-50', 
        text: 'text-slate-700',
        border: 'border-slate-100',
        icon: (
          <svg className="w-3.5 h-3.5 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        )
      }
    };
    
    return statusMap[status?.toLowerCase()] || statusMap.default;
  };

  const getStatConfig = (type) => {
    const configs = {
      'accepted': {
        icon: (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        ),
        bgColor: 'bg-emerald-500',
        gradient: 'from-emerald-50 to-white',
        textColor: 'text-emerald-600',
        countColor: 'text-emerald-900'
      },
      'pending': {
        icon: (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        ),
        bgColor: 'bg-amber-500',
        gradient: 'from-amber-50 to-white',
        textColor: 'text-amber-600',
        countColor: 'text-amber-900'
      },
      'rejected': {
        icon: (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        ),
        bgColor: 'bg-rose-500',
        gradient: 'from-rose-50 to-white',
        textColor: 'text-rose-600',
        countColor: 'text-rose-900'
      },
      'total': {
        icon: (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        ),
        bgColor: 'bg-slate-500',
        gradient: 'from-slate-50 to-white',
        textColor: 'text-slate-600',
        countColor: 'text-slate-900'
      }
    };
    return configs[type] || configs.total;
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <div className="relative inline-block">
            <div className="w-16 h-16 border-4 border-slate-100 rounded-full"></div>
            <div className="absolute top-0 left-0 w-16 h-16 border-4 border-blue-500 rounded-full border-t-transparent animate-spin"></div>
          </div>
          <p className="mt-4 text-sm font-medium text-slate-600">Loading applications...</p>
        </div>
      </div>
    );
  }

  if (isError) {
    console.log("Error is "+ isError)
    return (
      <div className="mx-auto max-w-xl mt-8">
        <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <div className="w-10 h-10 bg-rose-50 rounded-lg flex items-center justify-center">
                <svg className="w-5 h-5 text-rose-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
            <div className="ml-4">
              <h3 className="text-base font-semibold text-slate-900">Unable to load applications</h3>
              <p className="mt-1 text-sm text-slate-600">{error?.data?.message || 'Something went wrong. Please try again later.'}</p>
              <button 
                onClick={() => refetch()}
                className="mt-4 inline-flex items-center px-4 py-2 text-sm font-medium text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                Try Again
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!applications || applications.length === 0) {
    return (
      <div className="px-4 sm:px-6 lg:px-8 py-8 bg-white min-h-screen">
        <div className="max-w-md mx-auto mt-12 bg-white rounded-xl border border-slate-200 p-8 text-center">
          <div className="w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-10 h-10 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-slate-900 mb-2">No Applications Yet</h3>
          <p className="text-slate-600 mb-8">Start your financial journey by applying for your first loan.</p>
          <button 
            onClick={() => navigate('/apply-loan')}
            className="inline-flex items-center px-5 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
            </svg>
            Apply for a Loan
          </button>
        </div>
      </div>
    );
  }

  const stats = [
    { type: 'accepted', label: 'Accepted', count: applications.filter(app => app.status?.toLowerCase() === 'accepted').length },
    { type: 'pending', label: 'Pending', count: applications.filter(app => app.status?.toLowerCase() === 'pending').length },
    { type: 'total', label: 'Total', count: applications.length },
    { type: 'rejected', label: 'Rejected', count: applications.filter(app => app.status?.toLowerCase() === 'rejected').length }
  ];

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 bg-slate-50 min-h-screen">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h1 className="text-2xl font-semibold text-slate-900">Loan Applications</h1>
              <p className="mt-1 text-sm text-slate-600">Track and manage your loan applications</p>
            </div>
            <button
              onClick={() => navigate('/apply-loan')}
              className="inline-flex items-center px-4 py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
              </svg>
              New Application
            </button>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          {stats.map((stat) => {
            const config = getStatConfig(stat.type);
            return (
              <div 
                key={stat.type}
                className={`bg-gradient-to-br ${config.gradient} border border-slate-200 rounded-lg p-5 hover:border-slate-300 transition-colors`}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-slate-500 mb-2">{stat.label}</p>
                    <p className={`text-2xl font-semibold ${config.countColor}`}>{stat.count}</p>
                  </div>
                  <div className={`w-12 h-12 ${config.bgColor} rounded-lg flex items-center justify-center`}>
                    <div className="text-white">
                      {config.icon}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Table Card */}
        <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
          {/* Table Header */}
          <div className="px-6 py-4 border-b border-slate-200">
            <div className="flex items-center justify-between">
              <h2 className="text-base font-semibold text-slate-900">Application Details</h2>
              <span className="text-sm text-slate-500">{applications.length} applications</span>
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-slate-50">
                <tr>
                  {[
                    { key: 'applicationId', label: 'ID' },
                    { key: 'loanProductName', label: 'Product' },
                    { key: 'requestedAmount', label: 'Amount' },
                    { key: 'requestedTermMonths', label: 'Term' },
                    { key: 'interestRate', label: 'Rate' },
                    { key: 'status', label: 'Status' },
                    // { key: null, label: 'Actions' }
                  ].map((column) => (
                    <th
                      key={column.key}
                      onClick={() => column.key && handleSort(column.key)}
                      className={`px-6 py-3.5 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider ${column.key ? 'cursor-pointer hover:bg-slate-100 transition-colors' : ''}`}
                    >
                      <div className="flex items-center gap-1.5">
                        {column.label}
                        {column.key && sortConfig.key === column.key && (
                          <svg 
                            className={`w-4 h-4 text-blue-600 ${sortConfig.direction === 'descending' ? 'rotate-180' : ''}`} 
                            fill="none" 
                            stroke="currentColor" 
                            viewBox="0 0 24 24"
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7" />
                          </svg>
                        )}
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {sortedApplications.map((application) => {
                  const statusConfig = getStatusConfig(application.status);
                  return (
                    <tr 
                      key={application.applicationId}
                      className="hover:bg-slate-50 transition-colors"
                    >
                      <td className="px-6 py-4">
                        <span className="text-sm font-medium text-slate-900">#{application.applicationId}</span>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-3">
                          <div className="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center flex-shrink-0">
                            <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                          </div>
                          <div>
                            <p className="text-sm font-medium text-slate-900">{application.loanProductName || 'Personal Loan'}</p>
                            <p className="text-xs text-slate-500">
                              {new Date(application.requestedAt || Date.now()).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className="text-sm font-semibold text-slate-900">{formatCurrency(application.requestedAmount)}</span>
                      </td>
                      <td className="px-6 py-4">
                        <span className="text-sm text-slate-700">{application.requestedTermMonths || 'N/A'} months</span>
                      </td>
                      <td className="px-6 py-4">
                        <span className="text-sm font-medium text-slate-700">{formatInterest(application.interestRate)}</span>
                      </td>
                      <td className="px-6 py-4">
                        <span className={`inline-flex items-center px-3 py-1.5 rounded-lg text-xs font-medium border ${statusConfig.bg} ${statusConfig.text} ${statusConfig.border}`}>
                          {statusConfig.icon}
                          <span className="capitalize">{application.status || 'Pending'}</span>
                        </span>
                      </td>
                      {/* <td className="px-6 py-4">
                        <div className="flex items-center gap-2">
                          <button 
                            className="inline-flex items-center px-3 py-1.5 text-xs font-medium text-blue-700 bg-blue-50 rounded hover:bg-blue-100 transition-colors"
                            onClick={() => navigate(`/applications/${application.applicationId}`)}
                          >
                            <svg className="w-3.5 h-3.5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                            </svg>
                            View
                          </button>
                          <button 
                            className="p-1.5 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
                            title="Get Updates"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                            </svg>
                          </button>
                        </div>
                      </td> */}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* Table Footer */}
          <div className="px-6 py-4 border-t border-slate-200">
            <div className="flex items-center justify-between">
              <p className="text-sm text-slate-500">
                Showing <span className="font-medium text-slate-700">{applications.length}</span> applications
              </p>
              <div className="flex items-center gap-1">
                <button className="px-3 py-1.5 text-sm text-blue-600 hover:bg-blue-50 rounded transition-colors">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
                <button className="px-3 py-1.5 text-sm text-white bg-blue-600 rounded hover:bg-blue-700 transition-colors">
                  1
                </button>
                <button className="px-3 py-1.5 text-sm text-blue-600 hover:bg-blue-50 rounded transition-colors">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Help Section */}
        <div className="mt-8 bg-white border border-slate-200 rounded-lg p-6">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center flex-shrink-0">
              <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-slate-900 mb-1">Need assistance with your applications?</h4>
              <p className="text-sm text-slate-600 mb-3">
                Our support team is available to help you with any questions about your loan applications.
              </p>
              <button className="text-sm font-medium text-blue-600 hover:text-blue-700 transition-colors">
                Contact support →
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoanApplications;